import { ACCOUNT_ROUTE } from "../utils/consts";

const LOCAL_HOSTS = ["localhost", "127.0.0.1"];
const BASE_URL = process.env.REACT_APP_API_BASE_URL ||
  (LOCAL_HOSTS.includes(window.location.hostname) ? "http://127.0.0.1:8000" : "https://alfa-crypto.com");

type FetchOptions = RequestInit & {
  auth?: boolean;
};

const fetchClient = async (
  url: string,
  options: FetchOptions = {}
): Promise<Response> => {
  const fullUrl = `${BASE_URL}${url}`;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options.headers as Record<string, string>),
  };

  const response = await fetch(fullUrl, {
    ...options,
    headers,
    credentials: "include",
  });

  if (response.status === 401 && options.auth) {
    const isAccountRoute =
      window.location.pathname === ACCOUNT_ROUTE ||
      window.location.pathname.startsWith(`${ACCOUNT_ROUTE}/`);

    if (!isAccountRoute) {
      window.location.href = ACCOUNT_ROUTE;
    }
    throw new Error("Unauthorized");
  }

  return response;
};

export { fetchClient };
